module.exports = __webpack_public_path__ + "img/fan05.fef16456.png";